import styled from "styled-components";

const ShmupCardStyled = styled.li`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 5px;
  height: 320px;
  cursor: pointer;
  color: gray;

  .image {
    border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
    object-fit: cover;
    width: 250px;
    padding: 0px;
  }

  .text {
    width: 250px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    font-family: Oswald, sans-serif;
    font-weight: 600;
    font-size: 1.2rem;
    color: black;
    opacity: 0.8;
  }

  .details {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    font-weight: 600;
    border-radius: 0.2rem 0.2rem 0 0;
  }

  .numPlayers {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    padding: 3px;
  }
  .playersNumber {
    font-size: 1.3rem;
    font-weight: 800;
    color: black;
  }
  .playersText {
    margin-left: 0.15rem;
  }
`;

export default ShmupCardStyled;
